import { Theme } from '@mui/material/styles';
import * as R from 'ramda';
import { makeStyles } from 'tss-react/mui';
import { useShallow } from 'zustand/react/shallow';
import useWidth from '../../../../components/Hooks/useWidth';
import useGeneralSettingsStore from '../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { MediaFormatEnum } from '../../../general-settings/enums/mediaFormat.enum';
import { ProductMedia } from '../../ProductTypes';
import ProductDetailsContentHeaderButtons from '../../products-details-v2/components/ProductDetailsContentHeaderButtons/ProductDetailsContentHeaderButtons';
import ProductMediaColorSelector from '../../products-details-v2/components/ProductMediaColorSelector/ProductMediaColorSelector';
import { PRODUCT_DETAILS_GALLERY_Z_INDEX } from '../../products-details-v2/consts/productDetailsLayers.consts';
import ProductGalleryEmptyState from './components/ProductGalleryEmptyState/ProductGalleryEmptyState';
import RectangularGallery from './components/RectangularGallery/RectangularGallery';
import SquareGallery from './components/SquareGallery/SquareGallery';

const useStyles = makeStyles()((theme: Theme) => ({
  gallery: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    height: '100%',
    zIndex: PRODUCT_DETAILS_GALLERY_Z_INDEX,
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    },
  },
}));

type ProductDetailsGalleryProps = {
  isLoading: boolean;
  galleryWidth?: number;
  galleryHeight?: number;
  medias: ProductMedia[];
  onZoom: (media: ProductMedia, focusPercentToScroll?: number) => void;
};

const ProductDetailsGallery = ({
  isLoading,
  onZoom,
  medias,
  galleryWidth,
  galleryHeight,
}: ProductDetailsGalleryProps) => {
  const { classes } = useStyles();

  const { mediumDownWidth } = useWidth();
  const { mediaFormat } = useGeneralSettingsStore(
    useShallow((state) => ({
      mediaFormat: state.generalSettings.mediaFormat,
    })),
  );

  const Gallery = mediaFormat === MediaFormatEnum.SQUARE ? SquareGallery : RectangularGallery;

  const galleryProps = {
    medias,
    onZoom,
    onMobileContainerCover: true,
    galleryWidth: galleryWidth || 0,
    galleryHeight: galleryHeight || 0,
  };

  const hasMedias = !R.isEmpty(medias);
  const showEmptyState = !hasMedias && !isLoading;

  return (
    <div className={classes.gallery}>
      <ProductMediaColorSelector />

      {hasMedias && <Gallery {...galleryProps} />}

      {showEmptyState && <ProductGalleryEmptyState />}

      {mediumDownWidth && <ProductDetailsContentHeaderButtons />}
    </div>
  );
};

export default ProductDetailsGallery;
